module.exports = __webpack_public_path__ + "img/erp-logos_0017_sage200.91a3384e.jpg";